import axios, { AxiosResponse } from 'axios';
import * as utils from '@/apis/apiUtils';
import { RiverWaterLevelObservatoryResponse } from '@/models/apis/riverWaterLevelObservatory/riverWaterLevelObservatoryResponse';
import { RiverWaterLevelObservatorySearchParams } from '@/models/apis/riverWaterLevelObservatory/riverWaterLevelObservatoryRequest';

export default {
  getObservatories(params: RiverWaterLevelObservatorySearchParams): Promise<AxiosResponse<RiverWaterLevelObservatoryResponse>> {
    return axios.get(utils.getApiUrl('/river-water-level-observatories'), {
      params: params || {},
    });
  },
};
